import firebase from "firebase/app";
import "firebase/database";

export interface CustomBankConfig {
  bankCode?: string;
  firstname?: string;
  lastname?: string;
  accountno?: string;
  enabled?: boolean | string;
  showOnWeb?: boolean | string;
  note?: string;
}

export interface CustomBanksSiteConfig {
  slug: string;
  label: string;
  firebaseAppName?: string;
  firebaseConfig?: { [key: string]: string };
  websiteUrl: string;
  apiBaseUrl: string;
}

const shiba88Config: CustomBanksSiteConfig = {
  slug: "shiba-88",
  label: "Shiba888",
  firebaseAppName: "custombanks-shiba-88",
  websiteUrl: "https://shiba888.bet",
  apiBaseUrl: "https://asia-east2-shiba-88.cloudfunctions.net",
  firebaseConfig: {
    apiKey: "AIzaSyAnA8eb37qLxrfA3IuXV3rzEqxpE16hIII",
    authDomain: "shiba-88.firebaseapp.com",
    databaseURL:
      "https://shiba-88-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "shiba-88",
    storageBucket: "shiba-88.appspot.com",
    messagingSenderId: "831612083564",
    appId: "1:831612083564:web:10f037fa3ecd62e959a749"
  }
};

const siteAliases: { [key: string]: CustomBanksSiteConfig } = {
  "shiba-88": shiba88Config,
  shiba88: shiba88Config,
  shiba888: shiba88Config
};

export function normalizeSiteSlug(value?: string): string {
  return (value || "shiba-88")
    .toString()
    .trim()
    .toLowerCase();
}

export function getCustomBanksSiteConfig(
  value?: string
): CustomBanksSiteConfig {
  const slug = normalizeSiteSlug(value);
  if (siteAliases[slug]) return siteAliases[slug];

  return {
    slug,
    label: slug,
    websiteUrl: "",
    apiBaseUrl: ""
  };
}

export function getCustomBanksFirebaseApp(
  siteConfig: CustomBanksSiteConfig
): firebase.app.App {
  if (!siteConfig.firebaseConfig || !siteConfig.firebaseAppName) {
    return firebase.app();
  }

  for (let index = 0; index < firebase.apps.length; index += 1) {
    if (firebase.apps[index].name === siteConfig.firebaseAppName) {
      return firebase.apps[index];
    }
  }

  return firebase.initializeApp(
    siteConfig.firebaseConfig,
    siteConfig.firebaseAppName
  );
}

export function normalizeCustomBanks(customBanks: unknown): CustomBankConfig[] {
  if (!customBanks) return [];
  if (Array.isArray(customBanks)) {
    return customBanks.filter(Boolean) as CustomBankConfig[];
  }
  if (typeof customBanks === "object") {
    return Object.keys(customBanks as { [key: string]: CustomBankConfig })
      .map(key => (customBanks as { [key: string]: CustomBankConfig })[key])
      .filter(Boolean);
  }
  return [];
}

export function isEnabledFlag(value: unknown, fallback = true): boolean {
  if (value === undefined || value === null) return fallback;
  if (typeof value === "boolean") return value;
  const normalized = String(value)
    .trim()
    .toLowerCase();
  return !["0", "false", "no", "off", "disabled"].includes(normalized);
}

export function getVisibleCustomBanks(
  customBanks: unknown
): CustomBankConfig[] {
  return normalizeCustomBanks(customBanks).filter(bank => {
    if (!bank || !bank.bankCode || !bank.accountno) return false;
    return isEnabledFlag(bank.enabled) && isEnabledFlag(bank.showOnWeb);
  });
}

export function sanitizeExternalUrl(value?: string): string {
  const url = (value || "").toString().trim();
  if (!url) return "";
  return /^https?:\/\//i.test(url) ? url : "";
}

export function formatAccountNo(value?: string): string {
  return (value || "")
    .toString()
    .replace(/-/g, "")
    .replace(/\s/g, "");
}
